<template>
  <a
    class="home-location-card"
    :href="locationUrl"
    @click.prevent="$emit('select')"
  >
    <div
      class="home-location-card-image"
      :style="imageUrl ? { backgroundImage: `url('${imageUrl}')` } : undefined"
    />
    <div class="home-location-card-body">
      <h3 class="home-location-card-title">{{ name }}</h3>
      <p class="home-location-card-city">{{ city }}</p>
      <p v-if="priceLabel" class="home-location-card-price">{{ priceLabel }}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'HomeLocationCard',
  props: {
    name: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: false,
      default: ''
    },
    imageUrl: {
      type: String,
      required: false,
      default: null
    },
    slug: {
      type: String,
      required: false,
      default: ''
    },
    lowestPrice: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    locationUrl() {
      return this.slug ? `/locations/${this.slug}` : '/locations'
    },
    priceLabel() {
      if (!this.lowestPrice || !this.lowestPrice.amount) return ''
      return `${this.$t('home.locations.from')} ${this.$n(
        this.lowestPrice.amount,
        'currency'
      )} / ${this.lowestPrice.duration} min`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.home-location-card {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  padding: 0.75rem;
  color: inherit;
  text-decoration: none;
  transition: box-shadow 0.18s, transform 0.18s;

  &:hover {
    box-shadow: 0 10px 28px rgba(68, 74, 73, 0.1);
    transform: translateY(-2px);
    color: inherit;
    text-decoration: none;
  }
}

.home-location-card-image {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background-color: #edf1f0;
  background-size: cover;
  background-position: center;
}

.home-location-card-body {
  min-width: 0;
}

.home-location-card-title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: $ipBlack;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-location-card-city {
  margin: 0.125rem 0 0;
  font-size: 0.8125rem;
  color: $ipGreyDark;
}

.home-location-card-price {
  margin: 0.25rem 0 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: $ipGreen;
}
</style>
